import { CommonHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

const GetOrgRoleDataByRoleGroupIdData = (roleGroupId, state, setState) => {
  if (state.isArrayLoading !== true && roleGroupId > 0 && roleGroupId !== state.roleGroupId && !state.message) {
    let newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      roleGroupId,
      message: 'Loading...'
    };
    setState(newState);

    const roleGroupIdForUrl = roleGroupId ? encodeURIComponent(roleGroupId) : 'NaN';
    const url = `/OrgRole/OrgRoleGroup/${roleGroupIdForUrl}`;
    CommonHttpHelper(url, 'GET')
      .then((data) => {
        if (!data) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          newState = {
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            roleGroupId,
            arrayData: data,
            message: ''
          };
          setState(newState);
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

export default GetOrgRoleDataByRoleGroupIdData;